import React from "react";
import image1 from "../assets/image1.jpeg";
import image2 from "../assets/image2.jpeg";
import image3 from "../assets/image3.jpeg";
import image4 from "../assets/image4.jpeg";
import image5 from "../assets/image5.jpeg";
import image6 from "../assets/image6.jpeg";
import { useNavigate } from "react-router-dom";

const categories = [
  { id: 1, name: "Pet Foods (dry)", img: image1, category: "dry-food" },
  { id: 2, name: "Pet Toys", img: image2, category: "toys" },
  { id: 3, name: "Pet Clothes/Shoes", img: image3, category: "clothes-shoes" },
  { id: 4, name: "Pet grooming items", img: image4, category: "grooming" },
  { id: 5, name: "Pet Sanitary products", img: image5, category: "sanitary" },
  { id: 6, name: "Pet cages, beds, bags", img: image6, category: "cages-beds" },
];

const ProductCategories = () => {
  const navigate = useNavigate();
  const handleCategoryClick = (category) => {
    navigate('/shop', { state: { category: category.category } });
  };

  return (
    <div
      className="px-[5%] md:px-[8%] lg:px-[10%] min-h-[400px] py-8"
      style={{ backgroundColor: "#551E19" }}
    >
      <h2 className="text-start text-xl md:text-3xl ml-4 md:ml-7 font-semibold font-montserrat mb-6 text-[#E6B17E]">
        Product Categories
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:flex xl:justify-center gap-6 md:gap-6">
        {categories.map((category) => (
          <div
            key={category.id}
            className="rounded-3xl shadow-lg hover:shadow-[0_10px_25px_rgba(0,0,0,0.6)] transition-shadow p-3 md:p-4 w-full sm:w-40 md:w-44 flex flex-col items-center cursor-pointer"
            style={{ backgroundColor: "#551E19" }}
            onClick={() => handleCategoryClick(category)}
          >
            <img
              src={category.img}
              alt={category.name}
              className="w-24 h-24 md:w-32 md:h-32 object-cover rounded-md mb-3 md:mb-4"
            />
            <h3 className="text-center font-montserrat text-base md:text-lg text-white font-medium">
              {category.name}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductCategories;
